export const PROFILE_DB_REF = 'profile';
export const CATEGORY_DB_REF = 'category';
export const NONPROFIT_DB_REF = 'nonprofit';
export const NONPROFIT_REQUESTED_DB_REF = 'nonprofit_requested';
export const PROGRAM_DB_REF = 'nonprofit_programs';
